module.exports = __webpack_public_path__ + "/images/ico-custom-heart.728b050.png";